<div class="view-component">
    <div class="view-component-title">
        <span class="title">Ações do Dicionário de Dados</span>
    </div>
    <div class="content">
        <simple-datagrid entityName="Mktpdicaction" [parentRow]="parentRow" [condition]="condition" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
    </div>
</div> 